import React from 'react';
import { Box, Heading, Stack, Tooltip } from '@chakra-ui/react';

import { ProfileCheckbox } from '../elements/ProfileCheckbox';
import { ProfileField } from '../elements/ProfileField';
import { ProfileSelect } from '../elements/ProfileSelect';
import { sponsored } from '../data';
import { makeFields } from './utils';

export const Sponsored = ({ state, setter, onBlur }) => {
	const {
		firstName,
		lastName,
		phoneNumber,
		email,
		birthDate,
		citizenship,
		residence,
		englishSkills,
		enCert,
		frenchSkills,
		frCert,
		spouseMarital,
		children,
		criminality,
		healthIssues,
		canadaStatus,
		together,
		separately,
		intentions,
		countryOfMarriage,
		marriageDate,
		isVisaOpen,
		mutualKids,
		whatElse,
		docsSharedAccounts,
		docsFinHelp,
		docsSharedRent,
		docsSharedBills,
		docsSharedPurchases,
		docsSharedMail,
		docsSharedPictures,
		docsSharedTrips,
		docsSharedLogins,
		docsCallLogs,
	} = makeFields(state, setter, sponsored, onBlur);

	return (
		<Box>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...firstName} />
				<ProfileField pb={6} {...lastName} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...phoneNumber} />
				<ProfileField pb={6} {...email} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...birthDate} />
				<ProfileSelect pb={6} {...citizenship} />
				<ProfileSelect pb={6} {...residence} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileSelect pb={6} {...englishSkills} />
				<ProfileField pb={6} {...enCert} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileSelect pb={6} {...frenchSkills} />
				<ProfileField pb={6} {...frCert} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileSelect pb={6} {...spouseMarital} />
				<ProfileField pb={6} {...children} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...criminality} />
				<ProfileField pb={6} {...healthIssues} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...canadaStatus} />
				<ProfileCheckbox pb={6} {...isVisaOpen} />
				<ProfileCheckbox pb={6} {...mutualKids} />
			</Stack>
			{state.spouseMarital === 'commonLaw' && (
				<Stack direction={['column', 'row']}>
					<ProfileField pb={6} {...together} />
					<ProfileField pb={6} {...separately} />
					<ProfileField pb={6} {...intentions} />
				</Stack>
			)}
			{state.spouseMarital === 'official' && (
				<Stack direction={['column', 'row']}>
					<ProfileField pb={6} {...marriageDate} />
					<ProfileSelect pb={6} {...countryOfMarriage} />
				</Stack>
			)}
			<Tooltip
				label="Есть ли следующие документы (выбрать)"
				placement="top-start"
			>
				<Heading fontSize="md">
					Are documents present (choose all applicable)
				</Heading>
			</Tooltip>
			<Stack direction={['column', 'row']}>
				<ProfileCheckbox pb={6} {...docsSharedAccounts} />
				<ProfileCheckbox pb={6} {...docsFinHelp} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileCheckbox pb={6} {...docsSharedRent} />
				<ProfileCheckbox pb={6} {...docsSharedBills} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileCheckbox pb={6} {...docsSharedPurchases} />
				<ProfileCheckbox pb={6} {...docsSharedMail} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileCheckbox pb={6} {...docsSharedPictures} />
				<ProfileCheckbox pb={6} {...docsSharedTrips} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileCheckbox pb={6} {...docsSharedLogins} />
				<ProfileCheckbox pb={6} {...docsCallLogs} />
			</Stack>
			<Stack direction={['column', 'row']}>
				<ProfileField pb={6} {...whatElse} />
			</Stack>
		</Box>
	);
};
